import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { useQuery } from "@tanstack/react-query";

import { useApi } from "../../../../hooks/api/useApi";
import { useThemeChange } from "../../../../utils/themeChange";
import useAuthStore from "../../../../store/authStore";

import { ARTIST } from "../../../../constants/api-constants";
import ListArt from "../../Art/list/List";
import Button from "../../../../components/components/Button/Button";
// import ListCollection from "../../Collection/list/List";

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const { GET_BY_ARTIST_ID } = ARTIST;
// const { LIST_COLLECTIONS } = COLLECTION;

const ArtistDetail = function () {
  const { artist_id } = useParams();
  const navigate = useNavigate();
  const themeChange = useThemeChange();
  const { getById, getAll } = useApi();
  const { user } = useAuthStore((state) => ({ user: state.userLog }));

  // const [showArt, setShowArt] = useState(false);
  // const [showCollection, setShowCollection] = useState(true);

  // const [deleteArtistModal, setDeleteArtistModal] = useState(false);
  // const toggleDeleteArtistModal = (artist_id) => () => {
  //   setArtistToBeDelete(artist_id);
  //   setDeleteArtistModal((prev) => !prev);
  // };

  const artistDetail = useQuery({
    queryKey: ["artist"],
    queryFn: () => getById(artist_id, GET_BY_ARTIST_ID),
  });

  const artistArts = useQuery({
    queryKey: ["artistArts"],
    queryFn: () => getAll(`arts/artist/${artist_id}`),
  });

  // const getCollections = useQuery({
  //   queryKey: ["collection"],
  //   queryFn: () => getAll(LIST_COLLECTIONS),
  // });

  // if (getCollections.isSuccess) {
  //   var filteredCollections = getCollections?.data?.filter(
  //     (item) => item.artistId === artist_id
  //   );
  // }

  // const handleMyArt = async () => {
  //   if (showCollection) setShowCollection(!showCollection);
  //   setShowArt(!showArt);
  // };
  // const handleMyCollection = () => {
  //   setShowCollection(!showCollection);
  //   if (showArt) setShowArt(!showArt);
  // };

  return (
    <div className={themeChange.add("section")}>
      <GlobalStyles />
      {/* <CustomModal
            show={deleteArtistModal}
            onHide={toggleDeleteArtistModal}
          >
            <div className={themeChange.add("section-2")}>
              <div className="checkout">
                <div className="maincheckout">
                  <div className="row">
                    <div className="col">
                      <h3>Are you sure?</h3>
                    </div>
                    <div className="col-1">
                      <button
                        className="btn-close btn-close-white"
                        onClick={toggleDeleteArtistModal("")}
                      />
                    </div>
                  </div>

                  <p style={{ marginBottom: "0px" }}>
                    Artist will be removed From Gallery
                  </p>
                  <div className="d-flex flex-row align-items-center mt-3 ml-3">
                    <input
                      type="submit"
                      id="submit"
                      className="btn-main"
                      onClick={handleDeleteArtist}
                      value="Confirm"
                    />
                    <input
                      type="submit"
                      id="submit"
                      className="btn-main-secondary"
                      style={{ marginLeft: "10px" }}
                      onClick={toggleDeleteArtistModal("")}
                      value="Cancel"
                    />
                  </div>
                </div>
              </div>
            </div>
          </CustomModal> */}
      {artistDetail?.data && (
        <>
          <section className="container no-bottom">
            <div className="row">
              <div className="spacer-double"></div>
              <div className="d_profile de-flex">
                <div className="de-flex-col">
                  <div className="profile_avatar">
                    {artistDetail?.data?.profileImage ? (
                      <img src={artistDetail?.data?.profileImage} alt="" />
                    ) : (
                      <img src="../../img/author/dummy_author.png" alt="" />
                    )}
                    <div className="profile_name flex-column justify-content-center align-items-start">
                      <div className="d-flex flex-wrap">
                        <h4>
                          {artistDetail?.data?.firstName.concat(
                            " ",
                            artistDetail?.data?.lastName
                          ) || "-"}
                        </h4>
                        {user?.artist?.id === artistDetail?.data?.id && (
                          <>
                            <Link
                            // to={{
                            //   pathname: `/editArtist/${artistDetails?.artistId}`,
                            //   state: { galleryid: galleryDetails?._id },
                            // }}
                            >
                              <button id="btn_edit" title="Edit Text" disabled>
                                Edit
                              </button>
                            </Link>
                            {/* <span>
                              <button
                                id="btn_edit"
                                title="Delete NFT"
                                // onClick={toggleDeleteArtistModal(
                                //   artistDetails._id
                                // )}
                                disabled
                              >
                                Delete
                              </button>
                            </span> */}
                          </>
                        )}
                      </div>
                      {/* <h4
                        className="profile_username"
                        style={{ marginBottom: "1px" }}
                      >
                        {artistDetail?.data?.email || "-"}
                      </h4>
                      <Link
                        style={{ textDecoration: "none" }}
                        to={artistDetail?.data?.website}
                        target="_blank"
                      >
                        {artistDetail?.data?.website || "-"}
                      </Link>
                      <p> {artistDetail?.data?.contactNumber || "-"}</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* {user?.artist?.id === artistDetail?.data?.id && (
            <section className="container no-top mt-2">
              <div className="d-flex align-items-center justify-content-between light-theme-margin mb-5">
                <div className="d-flex align-items-center justify-content-between">
                  <ul className="de_nav">
                    <li id="Mainbtn" className="">
                      <span
                        className={showCollection ? "custom-border-color" : ""}
                        onClick={handleMyCollection}
                      >
                        My Collection
                      </span>
                    </li>
                    <li id="Mainbtn2" className="">
                      <span
                        className={showArt ? "custom-border-color" : ""}
                        onClick={handleMyArt}
                      >
                        My Arts
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {showArt && <ListArt artistArts={filteredArts} />}
              {showCollection && (
                <ListCollection artistCollections={filteredCollections} />
              )}
            </section>
          )} */}
          <section className="container no-top mt-2">
            {user?.artist?.id === artist_id && (
              <div className="d-flex justify-content-end mb-2">
                <Button
                  children="Create License"
                  onClick={() => navigate("/list-license")}
                />
              </div>
            )}
            <h3>Available Licensable Art</h3>
            <ListArt arts={artistArts?.data} />
          </section>
        </>
      )}
    </div>
  );
};
export default ArtistDetail;
